var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"count"},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"count-wrapper"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v(_vm._s(_vm.count))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }